/** Maximum number of Level 1 replies to show initially in the thread tree */
export const DEFAULT_MAX_THREAD_REPLIES = 3;
